var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthereum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1535,
    height: 2500,
    viewBox: "0 0 256 417",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M127.961 0l-2.795 9.5v275.668l2.795 2.79 127.962-75.638z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M127.962 0L0 212.32l127.962 75.639V154.158z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3B",
    d: "M127.961 312.187l-1.575 1.92v98.199l1.575 4.6L256 236.587z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M127.962 416.905v-104.72L0 236.585z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M127.961 287.958l127.96-75.637-127.96-58.162z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "M0 212.32l127.96 75.638v-133.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.cf8aa5e7c7ee6fe226057d2329059293.svg";
export { ForwardRef as ReactComponent };